import apiKey from './apiKey.js'
// export const login = data => apiKey.http.post('/login', data, {})
class ApiFetch {
    get(pampasCall, params={}) {
        return   apiKey.http.get(pampasCall, {params})
    }
    post(pampasCall, params) {
        return   apiKey.http.post(pampasCall, params,{})
    }
    postUpload(pampasCall, params) {
        return   apiKey.http.post(pampasCall, params,{timeout: 60000*60})
    }
    put(pampasCall, params) {
        return   apiKey.http.put(pampasCall, params,{})
    }
    delete(pampasCall, params) {
        return   apiKey.http.delete(pampasCall, params,{})
    }
    download(pampasCall, params) {
        return   apiKey.http.post(pampasCall, params,{responseType:'blob'})
    }
}
const apiFetch = new ApiFetch()
export default apiFetch